import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Cookies() {
  return (
    <div className="relative">
      <Navbar forceLight />
      <main className="bg-white">
        {/* Hero */}
        <section className="relative bg-[#f8f6f3] py-20 md:py-28">
          <div className="px-6 md:px-10 lg:px-16 max-w-5xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-[#1a1a1a] mb-4">
              Política de Cookies
            </h1>
            <p className="text-sm md:text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
              Te explicamos qué son las cookies, cuáles utilizamos en nuestro sitio y cómo puedes gestionar tus preferencias.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  1. ¿Qué son las Cookies?
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (ordenador, tablet o móvil) cuando visitas un sitio web. Las cookies permiten que el sitio recuerde tus acciones y preferencias durante un período de tiempo, para que no tengas que volver a introducirlas cada vez que regreses al sitio o navegues entre sus páginas.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  2. Tipos de Cookies que Utilizamos
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  En Esencia&co. utilizamos los siguientes tipos de cookies:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li><strong>Cookies técnicas o necesarias:</strong> Son esenciales para el funcionamiento básico del sitio web. Permiten funciones como la navegación por páginas, el acceso a áreas seguras y el correcto funcionamiento de formularios. Sin estas cookies, el sitio no puede operar correctamente.</li>
                  <li><strong>Cookies de preferencias:</strong> Permiten que el sitio web recuerde información que cambia la apariencia o el comportamiento del sitio, como tu idioma preferido o la región en la que te encuentras.</li>
                  <li><strong>Cookies analíticas:</strong> Nos ayudan a entender cómo interactúan los visitantes con nuestro sitio web, recopilando información de forma anónima. Estas cookies nos permiten mejorar continuamente la experiencia de usuario y los contenidos del sitio.</li>
                  <li><strong>Cookies de marketing:</strong> Se utilizan para rastrear a los visitantes en los sitios web. La intención es mostrar anuncios relevantes y atractivos para el usuario individual.</li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  3. Cookies Específicas que Usamos
                </h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-gray-600 border border-gray-200">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="text-left px-4 py-3 border-b border-gray-200 font-medium text-[#1a1a1a]">Nombre</th>
                        <th className="text-left px-4 py-3 border-b border-gray-200 font-medium text-[#1a1a1a]">Tipo</th>
                        <th className="text-left px-4 py-3 border-b border-gray-200 font-medium text-[#1a1a1a]">Duración</th>
                        <th className="text-left px-4 py-3 border-b border-gray-200 font-medium text-[#1a1a1a]">Finalidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="px-4 py-3 border-b border-gray-200">session_id</td>
                        <td className="px-4 py-3 border-b border-gray-200">Técnica</td>
                        <td className="px-4 py-3 border-b border-gray-200">Sesión</td>
                        <td className="px-4 py-3 border-b border-gray-200">Mantener la sesión del usuario activa</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3 border-b border-gray-200">_ga</td>
                        <td className="px-4 py-3 border-b border-gray-200">Analítica</td>
                        <td className="px-4 py-3 border-b border-gray-200">2 años</td>
                        <td className="px-4 py-3 border-b border-gray-200">Distinguir usuarios únicos (Google Analytics)</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3 border-b border-gray-200">_gid</td>
                        <td className="px-4 py-3 border-b border-gray-200">Analítica</td>
                        <td className="px-4 py-3 border-b border-gray-200">24 horas</td>
                        <td className="px-4 py-3 border-b border-gray-200">Distinguir sesiones de usuario (Google Analytics)</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3 border-b border-gray-200">cookie_consent</td>
                        <td className="px-4 py-3 border-b border-gray-200">Preferencia</td>
                        <td className="px-4 py-3 border-b border-gray-200">1 año</td>
                        <td className="px-4 py-3 border-b border-gray-200">Recordar las preferencias de cookies del usuario</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3">_fbp</td>
                        <td className="px-4 py-3">Marketing</td>
                        <td className="px-4 py-3">3 meses</td>
                        <td className="px-4 py-3">Entrega de anuncios en Facebook/Instagram</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  4. Gestión de Cookies
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  Puedes gestionar las cookies en cualquier momento a través de la configuración de tu navegador. A continuación te indicamos cómo hacerlo en los navegadores más comunes:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li><strong>Google Chrome:</strong> Menú → Configuración → Privacidad y seguridad → Cookies y otros datos de sitios</li>
                  <li><strong>Mozilla Firefox:</strong> Menú → Opciones → Privacidad y seguridad → Cookies y datos del sitio</li>
                  <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies y datos de sitios web</li>
                  <li><strong>Microsoft Edge:</strong> Configuración → Cookies y permisos del sitio → Cookies y datos del sitio</li>
                </ul>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mt-4">
                  Ten en cuenta que desactivar ciertas cookies puede afectar la funcionalidad del sitio web y limitar tu experiencia de navegación.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  5. Consentimiento
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Al acceder a nuestro sitio web por primera vez, se te mostrará un banner informativo sobre el uso de cookies. Al continuar navegando o hacer clic en "Aceptar", entendemos que consientes el uso de cookies según lo descrito en esta política. Puedes revocar tu consentimiento en cualquier momento modificando la configuración de cookies a través de tu navegador.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  6. Cookies de Terceros
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  En algunas páginas de nuestro sitio web se instalan cookies de terceros que nos permiten gestionar y mejorar los servicios que ofrecemos. Entre estos terceros se encuentran Google Analytics (para análisis de tráfico web) y redes sociales como Facebook e Instagram (para integración de contenido y marketing). Estas cookies están sujetas a las políticas de privacidad de sus respectivos titulares.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  7. Actualizaciones
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Esencia&co. puede actualizar esta política de cookies periódicamente para reflejar cambios en las cookies que utilizamos o por razones legales o regulatorias. Te recomendamos revisar esta página regularmente para mantenerte informado sobre cómo utilizamos las cookies.
                </p>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  8. Contacto
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Si tienes preguntas sobre nuestra política de cookies o deseas más información sobre cómo utilizamos estas tecnologías, puedes contactarnos en comercial@esenciayco.co o llamando al +57 311 2245754.
                </p>
              </div>
            </div>

            <div className="mt-16 pt-8 border-t border-gray-200">
              <p className="text-xs text-gray-400 text-center">
                Última actualización: mayo 2026
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}